import actions from 'actions/ecommerceActions';
import { getEcommerceAccountUrl } from 'utils/ecommerceUtils';
import { Ecommerce } from '@lifesize/types';
import { checkHttpStatus } from 'utils/http-utils';
import { Global } from 'state/Global';
import { authSelectors } from '@lifesize/nucleus';
import { Logger } from 'logger';

const thunks = {
  getEcommerceAccount: () => {
    return async (dispatch: Function, getState: () => Global) => {
      dispatch(actions.requestingEcommerceAccount());
      const state =  getState();
      const jwt = authSelectors.getPrimaryJwt(state);
      try {
        const checkUrl = await fetch(getEcommerceAccountUrl(jwt), {
          credentials: 'include'
        });
        const account: Ecommerce.Account = await checkHttpStatus(checkUrl).json();
        dispatch(actions.ecommerceAccountLoaded(account));
      } catch (e) {
        Logger.info('Unable to reach eCommerce service');
        dispatch(actions.ecommerceAccountFailure(e));
      }
    };
  },
};

export default thunks;
